import { Location } from '@angular/common';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE } from '../api-base.token';
import { 
  ShiftOccurrenceResponse, 
  UpdateStatusRequest 
} from './shift-occurrence.model';

@Injectable({
  providedIn: 'root',
})
export class ShiftOccurrencesHttpService {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject(API_BASE)
    private readonly apiBase: string
  ) {}

  getShiftOccurrences(
    workspaceId: string,
    startDate?: Date,
    endDate?: Date
  ): Observable<ShiftOccurrenceResponse[]> {
    const url = Location.joinWithSlash(
      this.apiBase,
      `workspaces/${workspaceId}/shift-occurrences`
    );

    let params = new HttpParams();
    if (startDate) {
      params = params.set('startDate', startDate.toISOString());
    }
    if (endDate) {
      params = params.set('endDate', endDate.toISOString());
    }

    return this.httpClient.get<ShiftOccurrenceResponse[]>(url, { params });
  }

  getShiftOccurrence(
    workspaceId: string,
    occurrenceId: number
  ): Observable<ShiftOccurrenceResponse> {
    const url = Location.joinWithSlash(
      this.apiBase,
      `workspaces/${workspaceId}/shift-occurrences/${occurrenceId}`
    );

    return this.httpClient.get<ShiftOccurrenceResponse>(url);
  }

  updateShiftOccurrenceStatus(
    workspaceId: string,
    occurrenceId: number,
    request: UpdateStatusRequest
  ): Observable<void> {
    const url = Location.joinWithSlash(
      this.apiBase,
      `workspaces/${workspaceId}/shift-occurrences/${occurrenceId}/status`
    );

    return this.httpClient.put<void>(url, request);
  }
}